import useTracker from './useTracker';

const Tracker = () => {
  useTracker();

  return null;
};

export default Tracker;
